import { createAction, props } from '@ngrx/store';
import { NotificationModel } from '../../models/Notification.model';

export enum NotificationsActionTypes {
  getNotificationsBegin = '[Messages] Get Notifications begin',
  getNotificationsSuccess = '[Messages] Get Notifications success',
  getNotificationsFail = '[Messages] Get Notifications failure',

  setNotificationAsReadBegin = '[Messages] Set Notification as Read begin',
  setNotificationAsReadSuccess = '[Messages] Set Notification as Read success',
  setNotificationAsReadFail = '[Messages] Set Notification as Read failure',
}

export const getNotificationsBeginAction = createAction(
  NotificationsActionTypes.getNotificationsBegin
);
export const getNotificationsSuccessAction = createAction(
  NotificationsActionTypes.getNotificationsSuccess,
  props<{ payload: any }>()
);
export const getNotificationsFailAction = createAction(
  NotificationsActionTypes.getNotificationsFail,
  props<{ errors: any }>()
);

// SET AS READ
export const setNotificationAsReadBeginAction = createAction(
  NotificationsActionTypes.setNotificationAsReadBegin,
  props<{ id: number }>()
);
export const setNotificationAsReadSuccessAction = createAction(
  NotificationsActionTypes.setNotificationAsReadSuccess,
  props<{
    payload: NotificationModel[];
  }>()
);
export const setNotificationAsReadFailAction = createAction(
  NotificationsActionTypes.setNotificationAsReadFail,
  props<{ errors: any }>()
);
